import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { AlertCircle, X, RefreshCw } from 'lucide-react';

const CancelTableModal = ({ mesa, cancelingMesa, onConfirm, onCancel, formatDuration }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" data-testid="cancel-confirm-modal">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-red-600">
            <AlertCircle size={24} />
            Cancelar Mesa {mesa.numero}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center py-4 bg-red-50 rounded-lg border border-red-200">
            <p className="text-gray-700 mb-2">Estas seguro de que quieres cancelar esta mesa?</p>
            {mesa.session && (
              <div className="space-y-1">
                <p className="text-sm text-gray-500">
                  {mesa.session.order_count} pedido(s) · {formatDuration(mesa.session.duration_minutes)}
                </p>
                <p className="text-lg font-bold text-red-600">
                  Total: {mesa.session.total.toFixed(2)}€
                </p>
              </div>
            )}
            <p className="text-xs text-red-500 mt-3 font-medium">
              Esta accion cerrara la mesa sin cobrar
            </p>
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            <Button
              variant="outline"
              onClick={onCancel}
              disabled={cancelingMesa}
            >
              No, volver
            </Button>
            <Button
              onClick={() => onConfirm(mesa.numero)}
              disabled={cancelingMesa}
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              {cancelingMesa ? (
                <RefreshCw className="animate-spin mr-2" size={16} />
              ) : (
                <X size={16} className="mr-2" />
              )}
              Si, cancelar
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CancelTableModal;
